import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';

const form = document.querySelector('#daily-grace-subscribe');

const {loggedIn} = global;

class DailyGraceSubscribe extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            showModal: false,
            success: false,
            errorMessage: null,
            firstname: "",
            lastname: "",
            email: "",
            csrf_token: null,
            modalMessage: ""
        };

        this.handleSubscribe = this.handleSubscribe.bind(this);
    }

    submitDGI(){
        var _self = this;
        var formData =  {
            "email"     : $( '[name=dgi__email_embed]' ).val(),
            "firstname" : $( '[name=dgi__firstname_embed]' ).val(),
            "lastname"  : $( '[name=dgi__lastname_embed]' ).val(),
            "previousUrl": window.location.href
        };

        $.ajax({
            type: 'POST',
            url: '/newsletters/web-api/dgi',
            data: formData,
            dataType: 'json',
            beforeSend: function(xhr) {
                xhr.setRequestHeader('X-CSRF-TOKEN', _self.state.csrf_token); // very important
            },
            success: function(data){
                var subscriptionStatus = data.previous_subscription_status;
                var message = "";
                if(subscriptionStatus==='SUBSCRIBED'){
                    message = "This email address is already subscribed.";
                } else if(subscriptionStatus==='PENDING'){
                    message = "A confirmation email has already been sent to you. Please check your email to confirm your subscription.";
                } else if (subscriptionStatus==='UNSUBSCRIBED'){
                    message = "Thank you for subscribing.";
                } else { //NOT_SUBSCRIBED
                    message = "Thank you for subscribing. A confirmation email has been sent to you to confirm your subscription.";
                }

                _self.setState({showModal: true, isLoading: false, success: true, errorMessage: null, modalMessage: message});
                $('#daily-grace-modal').modal('show');
            },
            error: function (data) {
                _self.setState({isLoading: false, success: false, showModal: false});
                if(typeof data.responseJSON !== 'undefined') {
                    _self.setState({errorMessage: data.responseJSON.error });
                    Bugsnag.leaveBreadcrumb(data.responseJSON.error);
                } else {
                    _self.setState({errorMessage: ["Please try again."] });
                    Bugsnag.notify("Error submitting DGI Subscribe", "No response");
                }
            }
        });
    }

    componentWillMount(){
        form.addEventListener('submit', this.handleSubscribe);
    }

    componentDidMount() {
        var _self = this;
        _self.setState({csrf_token: $( 'input[name="_token"]' ).val() });
    }

    handleSubscribe(e) {
        e.preventDefault();
        this.setState({
            isLoading: true,
            email: $( '[name=dgi__email_embed]' ).val(),
            firstname: $( '[name=dgi__firstname_embed]' ).val(),
            lastname: $( '[name=dgi__lastname_embed]' ).val()
        });

        this.submitDGI();
    }

    handleCloseModal(e){
        e.preventDefault();
        $('#daily-grace-modal').modal('hide');
        this.setState({showModal: false});
    }

    render() {
        var createAccountURL = "/register?source=dgi&new=true&firstname=" + encodeURIComponent(this.state.firstname) + "&lastname=" + encodeURIComponent(this.state.lastname) + "&email=" + encodeURIComponent(this.state.email);
        return (
            <span>
                <button className={(this.state.isLoading) ? 'btn btn-white' : 'btn btn-primary'} type="submit"  style={{'minWidth': '140px'}}>
                    {(this.state.isLoading) ?
                        <span>Please Wait <i className="fa fa-circle-o-notch fa-spin" style={{fontSize: '18px !important'}}></i></span>
                    : 'Subscribe'}
                </button>

                {(this.state.errorMessage !== null) ?
                    this.state.errorMessage.map((errorMsg, key) =>
                        <div key={key} className="text-danger">
                            {errorMsg}<br/>
                        </div>
                    )
                    : ''}

                {(this.state.showModal) ?
                <div className="modal fade" id="daily-grace-modal" tabIndex="-1" role="dialog" aria-labelledby="messageModal" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" style={{'paddingLeft': '15px'}}>{(this.state.isLoading) ? '' : (this.state.success) ? 'Thank you' : 'Error'}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{'textAlign': 'left', 'padding': '0 30px 30px 30px'}}>
                                {(this.state.isLoading) ?
                                    <div className="text-center">
                                        <p className="text-center">Subscribing...</p>

                                    </div>
                                :
                                    (this.state.success) ?
                                        <div>
                                            <p> {this.state.modalMessage} </p>
                                            {(!loggedIn) ?
                                                <span>
                                                    <p className="lead mb-1" style={{'paddingTop': '15px', 'borderTop': '1px solid #9b9b9b'}}>
                                                        Would you like to create an account?
                                                    </p>
                                                    <p>
                                                        With an account, you can watch the past week’s episodes for free via our On Demand. And if you’re new to the ministry, we would like to bless you with a FREE sermon CD by Joseph Prince.
                                                        <br /><small>*Free sermon CD only for US residents who do not yet have an account.</small>
                                                    </p>
                                                </span>
                                            :''}
                                        </div>
                                        :
                                        ''
                                }
                            </div>
                            {(this.state.isLoading) ?
                                ''
                                :
                                (this.state.success && !loggedIn) ?
                                <div style={{padding: '30px'}}>
                                    <button type="button" className="btn btn-gray hidden-sm-down" data-dismiss="modal" style={{'marginRight': '15px'}}>No, Thank You</button>
                                    <a href={createAccountURL} className="btn btn-primary btn-block-mobile">Create Account</a>
                                    <button type="button" className="btn btn-gray hidden-md-up btn-block-mobile" data-dismiss="modal" style={{'marginTop': '15px'}}>No, Thank You</button>
                                </div>
                                :
                                <div  style={{padding: '30px'}}>
                                    <button type="button" className="btn btn-primary" data-dismiss="modal">OK</button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                : ''}
            </span>
        )
    }
}

ReactDOM.render(<DailyGraceSubscribe/>, document.getElementById('daily-grace-subscribe-react'));
